import { type CostCenter2 } from "@finway-group/shared/lib/models"
import { Select, type SelectProps } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { NOT_SET_VALUE } from "~Shared/config/consts"
import { doFilterSelect } from "~Shared/utils/helper.utils"
import { type GetPopupAnchor } from "~Shared/utils/popup.utils"

interface CostCenter2SelectProps extends SelectProps {
    costCenters2: Array<CostCenter2>
    getPopupAnchor: GetPopupAnchor
}

export const CostCenter2Select = ({ costCenters2, getPopupAnchor, ...selectProps }: CostCenter2SelectProps) => {
    const { t } = useTranslation()
    const placeholder = selectProps?.placeholder || t("placeholder:cost_center_2.select_a_cost_center_2")
    const notFoundContent = selectProps?.notFoundContent || t("missing:no_cost_center_2")

    return (
        <Select {...selectProps} showSearch filterOption={doFilterSelect} getPopupContainer={getPopupAnchor()} placeholder={placeholder} notFoundContent={notFoundContent}>
            <Select.Option value={NOT_SET_VALUE} label="">
                <div className="flex items-center">
                    <span>{t("missing:request.cost_center_2")}</span>
                </div>
            </Select.Option>
            {costCenters2.map((costCenter2, index) => (
                <Select.Option key={costCenter2._id} value={costCenter2._id} label={costCenter2.name} id={`costcenter2-option-${index}`}>
                    {costCenter2.name}
                </Select.Option>
            ))}
        </Select>
    )
}
